import view from './recover-password'
export default view
